function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M20.87,63.2s-.11,0-.11-.11c-.32-.21-.53-.53-.53-.85L11.55,21.25c-.11-.74.32-1.38,1.06-1.59l2.12-.42c0-.95.21-1.91.64-2.86l-3.28.74c-2.12.42-3.5,2.54-3.07,4.66l8.69,40.99c.42,1.8,2.01,3.07,3.81,3.07.32,0,.53,0,.85-.11l.42-.11c-.95-.53-1.59-1.38-1.91-2.44"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M26.27,62.03c-.32-.21-.53-.53-.64-.95l-5.83-41.52c-.11-.74.42-1.38,1.06-1.48h0l2.22-.32c.11-.95.53-1.91,1.06-2.75l-3.71.53c-2.12.32-3.6,2.33-3.39,4.45h0l5.83,41.52c.32,1.91,1.91,3.39,3.92,3.39h.74c-.53-.95-1.06-1.91-1.27-2.86"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M32.94,14.47l-3.5.21c-2.12.11-3.81,2.01-3.6,4.24l2.97,41.84c.11,2.01,1.8,3.6,3.92,3.71h.85c-.64-.74-1.17-1.69-1.38-2.75-.42-.21-.64-.64-.64-1.06l-2.97-41.84c0-.74.53-1.38,1.17-1.38l2.22-.21c0-1.06.32-1.91.95-2.75"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M67.15,14.16h-28.81c-2.12,0-3.92,1.8-3.92,3.92v41.95c0,2.12,1.8,3.92,3.92,3.92h28.81c2.12,0,3.92-1.8,3.92-3.92V18.18c0-2.22-1.8-4.03-3.92-4.03M68.43,60.02c0,.74-.64,1.27-1.27,1.27h-28.81c-.74,0-1.27-.64-1.27-1.27V18.18c0-.74.64-1.27,1.27-1.27h28.81c.74,0,1.27.64,1.27,1.27v41.84Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M56.99,32.59c-1.17-.95-2.22-2.01-3.18-3.18l-1.06-1.59-1.06,1.59c-.95,1.17-2.01,2.22-3.18,3.07-3.18,2.75-7.63,6.57-4.98,11.65.74,1.27,1.91,2.22,3.28,2.54.42.11.95.21,1.38.21,1.06,0,2.12-.32,2.97-.85.11,0,.11-.11.21-.11v1.65h-1.8v2.65h6.25v-2.65h-1.8v-1.65c.11,0,.11.11.21.11,1.27.85,2.86,1.06,4.34.74,1.38-.32,2.65-1.27,3.28-2.54,2.75-5.19-1.59-8.9-4.87-11.65M59.63,42.86c-.32.64-.95,1.17-1.69,1.27-.74.21-1.59.11-2.33-.42-1.8-1.06-4.03-1.06-5.83,0-.64.42-1.48.53-2.33.42-.74-.21-1.27-.64-1.69-1.27-1.59-2.97.64-5.3,4.34-8.47.95-.74,1.8-1.59,2.54-2.33.74.74,1.69,1.59,2.54,2.33,3.71,3.28,6.04,5.51,4.45,8.47"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/TableGames-inactive.0ff4a506.svg";
export { SvgComponent as ReactComponent };